
























































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import path from 'path';
import urlJoin from 'url-join';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { SHOP_ANCHOR } from '~/constants';
import { S3_BASE_FILE_DIR } from '~/constants/contents';
import { ECSchema } from '~/types/api';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
  },
  props: {
    shopDetail: {
      type: Object as PropType<ECSchema<'saleslocation.ShowResponse'>>,
      required: true,
    },
  },
  setup(props) {
    // PDF プレビュー用のパスに変換する
    const formatPreviewUrl = (pdfUrl: string) => {
      return urlJoin(S3_BASE_FILE_DIR, path.basename(pdfUrl));
    };

    // メニューが存在するか
    const hasShopMenu = computed(() => {
      return props.shopDetail.menu_pdf || props.shopDetail.menu_special_pdf;
    });

    return {
      SHOP_ANCHOR,
      formatPreviewUrl,
      hasShopMenu,
    };
  },
});
